import { render, staticRenderFns } from "./ScientistSearchResultCard.vue?vue&type=template&id=7a2d6a8d&"
import script from "./ScientistSearchResultCard.vue?vue&type=script&lang=ts&"
export * from "./ScientistSearchResultCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports